import React, { Component } from 'react';

const textOverflow = {
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
};

export class UserCard extends Component{
    render(){
      let emailblock, telblock;
      if (this.props.email) {
        emailblock = (
          <p style={{ display: 'inline' }}><a href={'mailto:' +this.props.email}>{this.props.email}</a></p>
        )
      }
      if (this.props.tel) {
        telblock = (
          <p style={{ display: 'inline' }}><a href={'tel:' +this.props.tel}>{this.props.tel}</a></p>
        )
      }
      return (
          <div className="card card-user">
              <div className="image">
                  <img src={this.props.bgImage} alt="..."/>
              </div>
              <div className="content">
                  <div className="author">
                          <img className="avatar border-gray" src={this.props.avatar} alt="..."/>
                          <h4 className="title">
                              {this.props.name}
                              <br />
                              <small title={this.props.profession} style={{ ...textOverflow, display: 'inherit' }}>
                                {this.props.profession}
                              </small>
                          </h4>
                  </div>
                  <div className="description text-center" style={textOverflow}>
                    {emailblock}
                    {telblock}
                  </div>
                  <div className="description text-center" style={textOverflow} title={this.props.expertise}>
                    <span>
                      {this.props.expertise}
                    </span>
                  </div>
                  <div className="description text-center" style={textOverflow} title={this.props.extras}>
                      {this.props.extras}
                  </div>
              </div>
              <hr />
              <div className="text-right" style={textOverflow}>
                  {this.props.socials}
              </div>
          </div>
      );
    }
}

export default UserCard;



// WEBPACK FOOTER //
// ./src/components/Card/UserCard.jsx